import { urlUtil } from '@cmg/common';

// The subdomain of the account the user is logged in with. This should not be modified.
export const selectSelfSubdomain = () => urlUtil.getAccountSubdomain(window.location);
